import { get, put, del } from '@/api/apiService.ts';
import type { NotificationResponse, UnreadCountResponse } from '@/types/notification.ts';

const notificationService = {
  getAll(): Promise<NotificationResponse[]> {
    return get<NotificationResponse[]>('/api/notifications');
  },

  getUnreadCount(): Promise<UnreadCountResponse> {
    return get<UnreadCountResponse>('/api/notifications/unread-count');
  },

  markAsRead(id: string): Promise<void> {
    return put<undefined, void>(`/api/notifications/${id}/read`, undefined);
  },

  markAllAsRead(): Promise<void> {
    return put<undefined, void>('/api/notifications/read-all', undefined);
  },

  deleteRead(): Promise<void> {
    return del<void>('/api/notifications/read');
  },
};

export default notificationService;
